// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   AppBar,
//   Toolbar,
//   IconButton,
//   TextField,
//   Card,
//   CardContent,
//   InputAdornment,
//   Avatar,
//   Divider,
//   Button,
//   Collapse,
//   Tabs,
//   Tab,
//   Grid,
//   Chip,
//   Checkbox,
//   FormControlLabel,
//   Paper,
//   List,
//   ListItem,
//   ListItemText,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions
// } from "@mui/material";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import SearchIcon from "@mui/icons-material/Search";
// import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import ExpandLessIcon from "@mui/icons-material/ExpandLess";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import AddIcon from "@mui/icons-material/Add";
// import CloseIcon from "@mui/icons-material/Close";
// import { useNavigate } from "react-router-dom";
// import FormsBottomNavbar from "../Post Module/FormsBottomNavbar";

// // Import filtration utilities
// import {
//   tabs,
//   popularCities,
//   propertyTypes,
//   filterProperties,
//   locationHandlers,
//   propertyTypeHandlers,
//   utilityFunctions
// } from "./propertyFilters";

// const OnePage = () => {
//   const navigate = useNavigate();
//   const [searchQuery, setSearchQuery] = useState("");
//   const [activeCommentIndex, setActiveCommentIndex] = useState(null);
//   const [commentText, setCommentText] = useState("");
//   const [propertyLink, setPropertyLink] = useState("");
//   const [properties, setProperties] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [responses, setResponses] = useState({});
//   const [submitting, setSubmitting] = useState(false);
//   const [expandedResponses, setExpandedResponses] = useState({});
//   const [activeTab, setActiveTab] = useState(0);
//   const [locationDialogOpen, setLocationDialogOpen] = useState(false);
//   const [selectedLocations, setSelectedLocations] = useState([]);
//   const [useCurrentLocation, setUseCurrentLocation] = useState(false);
//   const [propertyTypeDialogOpen, setPropertyTypeDialogOpen] = useState(false);
//   const [selectedPropertyTypes, setSelectedPropertyTypes] = useState([]);

//   // Color scheme matching your dashboard
//   const colors = {
//     primary: "#1a1a1a", // Dark black
//     secondary: "#8B7355", // Coffee brown
//     accent: "#A52A2A", // Rich brown
//     background: "#b9a990", // Light beige background
//     cardBackground: "#FFFFFF",
//     textDark: "#1a1a1a",
//     textLight: "#FFFFFF",
//     textMuted: "#666666"
//   };

//   // Fetch properties data from API
//   useEffect(() => {
//     const fetchProperties = async () => {
//       try {
//         setLoading(true);
//         const response = await fetch(`${BASE_URL}/property-request/`);

//         if (!response.ok) {
//           throw new Error(`HTTP error! status: ${response.status}`);
//         }

//         const data = await response.json();
//         const reversedData = data.slice().reverse();
//         setProperties(reversedData);
//         setError(null);
//       } catch (err) {
//         console.error("Error fetching properties:", err);
//         setError("Failed to load properties. Please try again later.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProperties();
//   }, []);

//   // Fetch responses for properties
//   useEffect(() => {
//     const fetchResponses = async () => {
//       try {
//         const response = await fetch(`${BASE_URL}/response-property-request/`);
//         if (response.ok) {
//           const data = await response.json();
//           // Group responses by req_id
//           const responsesByReqId = {};
//           data.forEach(response => {
//             if (!responsesByReqId[response.req_id]) {
//               responsesByReqId[response.req_id] = [];
//             }
//             responsesByReqId[response.req_id].push(response);
//           });
//           setResponses(responsesByReqId);
//         }
//       } catch (err) {
//         console.error("Error fetching responses:", err);
//       }
//     };

//     fetchResponses();
//   }, []);

//   // Use imported utility functions
//   const { formatBudget, formatDate, getUserInitials } = utilityFunctions;

//   // Use imported handlers
//   const {
//     handleLocationSelect,
//     handleLocationRemove,
//     handleUseCurrentLocation
//   } = locationHandlers;

//   const { handlePropertyTypeSelect } = propertyTypeHandlers;

//   const handleCommentClick = (index) => {
//     if (activeCommentIndex === index) {
//       setActiveCommentIndex(null);
//     } else {
//       setActiveCommentIndex(index);
//     }
//     setCommentText("");
//     setPropertyLink("");
//   };

//   const handleSubmitResponse = async (reqId, userId) => {
//     if (!commentText.trim() && !propertyLink.trim()) {
//       alert("Please enter either a comment or property link");
//       return;
//     }

//     setSubmitting(true);
//     try {
//       const response = await fetch(`${BASE_URL}/response-property-request/`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           comment: commentText,
//           proerty_link: propertyLink,
//           req_id: reqId,
//           user_id: userId, // This should be the logged-in user's ID
//         }),
//       });

//       if (response.ok) {
//         const newResponse = await response.json();
//         // Update local state with the new response
//         setResponses(prev => ({
//           ...prev,
//           [reqId]: [...(prev[reqId] || []), newResponse]
//         }));

//         setCommentText("");
//         setPropertyLink("");
//         setActiveCommentIndex(null);
//         alert("Response submitted successfully!");
//       } else {
//         throw new Error("Failed to submit response");
//       }
//     } catch (err) {
//       console.error("Error submitting response:", err);
//       alert("Failed to submit response. Please try again.");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const toggleResponses = (reqId) => {
//     setExpandedResponses(prev => ({
//       ...prev,
//       [reqId]: !prev[reqId]
//     }));
//   };

//   const handleTabChange = (event, newValue) => {
//     setActiveTab(newValue);
//   };

//   const applyFilters = () => {
//     setLocationDialogOpen(false);
//     setPropertyTypeDialogOpen(false);
//   };

//   // Filter properties using the imported function
//   const filteredProperties = filterProperties(properties, {
//     searchQuery,
//     activeTab,
//     selectedLocations,
//     selectedPropertyTypes,
//     tabs
//   });

//   if (loading) {
//     return (
//       <Box
//         className="property-requests-loading-container"
//         sx={{
//           display: "flex",
//           flexDirection: "column",
//           minHeight: "100vh",
//           backgroundColor: colors.background,
//           justifyContent: "center",
//           alignItems: "center"
//         }}
//       >
//         <Typography variant="h6" color={colors.textDark}>
//           Loading properties...
//         </Typography>
//       </Box>
//     );
//   }

//   if (error) {
//     return (
//       <Box
//         className="property-requests-error-container"
//         sx={{
//           display: "flex",
//           flexDirection: "column",
//           minHeight: "100vh",
//           backgroundColor: colors.background,
//           justifyContent: "center",
//           alignItems: "center"
//         }}
//       >
//         <Typography variant="h6" color="error">{error}</Typography>
//       </Box>
//     );
//   }

//   return (
//     <Box
//       className="property-requests-main-container"
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         minHeight: "100vh",
//         backgroundColor: colors.background,
//       }}
//     >
//       {/* Header */}
//       <AppBar
//         className="property-requests-app-bar"
//         position="static"
//         sx={{
//           backgroundColor: colors.primary,
//           color: colors.textLight,
//         }}
//       >
//         <Toolbar className="property-requests-toolbar">
//           <IconButton 
//             className="property-requests-back-button"
//             onClick={() => navigate(-1)} 
//             sx={{ color: colors.textLight }}
//           >
//             <ArrowBackIosNewIcon />
//           </IconButton>
//           <Typography 
//             className="property-requests-title"
//             variant="h6" 
//             sx={{ ml: 2 }}
//           >
//             Property Requests
//           </Typography>
//         </Toolbar>
//       </AppBar>

//       {/* Search Bar */}
//       <Box 
//         className="property-requests-search-container"
//         sx={{ p: 2, backgroundColor: colors.cardBackground }}
//       >
//         <TextField
//           className="property-requests-search-field"
//           fullWidth
//           variant="outlined"
//           placeholder="Search upto 3 localities or landmarks"
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start">
//                 <SearchIcon sx={{ color: colors.secondary }} />
//               </InputAdornment>
//             ),
//           }}
//           sx={{
//             '& .MuiOutlinedInput-root': {
//               borderRadius: 2,
//               backgroundColor: '#f8f8f8',
//               '&:hover fieldset': {
//                 borderColor: colors.secondary,
//               },
//               '&.Mui-focused fieldset': {
//                 borderColor: colors.secondary,
//               },
//             }
//           }}
//         />
//       </Box>

//       {/* Filter Chips */}
//       <Box 
//         className="property-requests-filter-chips-container"
//         sx={{ p: 2, backgroundColor: colors.cardBackground, borderBottom: '1px solid #e0e0e0' }}
//       >
//         <Box 
//           className="property-requests-filter-chips-row"
//           sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 1 }}
//         >
//           <Chip
//             className="property-requests-location-chip"
//             label="Add Locations"
//             onClick={() => setLocationDialogOpen(true)}
//             variant="outlined"
//             deleteIcon={<AddIcon />}
//             onDelete={() => setLocationDialogOpen(true)}
//             sx={{
//               borderColor: colors.secondary,
//               color: colors.secondary,
//               '& .MuiChip-deleteIcon': {
//                 color: colors.secondary,
//               }
//             }}
//           />
//           <Chip
//             className="property-requests-type-chip"
//             label="Plot/ Building"
//             onClick={() => setPropertyTypeDialogOpen(true)}
//             variant="outlined"
//             deleteIcon={<AddIcon />}
//             onDelete={() => setPropertyTypeDialogOpen(true)}
//             sx={{
//               borderColor: colors.secondary,
//               color: colors.secondary,
//               '& .MuiChip-deleteIcon': {
//                 color: colors.secondary,
//               }
//             }}
//           />
//         </Box>

//         {/* Selected Locations */}
//         {selectedLocations.map((location, index) => (
//           <Chip
//             key={index}
//             className="property-requests-selected-location-chip"
//             label={location}
//             onDelete={() => handleLocationRemove(selectedLocations, setSelectedLocations, location)}
//             sx={{
//               m: 0.5,
//               backgroundColor: colors.secondary,
//               color: colors.textLight,
//               '& .MuiChip-deleteIcon': {
//                 color: colors.textLight,
//               }
//             }}
//           />
//         ))}
//       </Box>

//       {/* Popular Cities Section */}
//       <Box 
//         className="property-requests-popular-cities-container"
//         sx={{ p: 2, backgroundColor: colors.cardBackground }}
//       >
//         <Typography
//           className="property-requests-popular-cities-title"
//           variant="h6"
//           sx={{
//             mb: 2,
//             fontWeight: 'bold',
//             color: colors.primary
//           }}
//         >
//           Popular cities in India
//         </Typography>
//         <Box 
//           className="property-requests-popular-cities-chips"
//           sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}
//         >
//           {popularCities.map((city, index) => (
//             <Chip
//               key={index}
//               className="property-requests-popular-city-chip"
//               label={city}
//               onClick={() => handleLocationSelect(selectedLocations, setSelectedLocations, city)}
//               variant="outlined"
//               sx={{
//                 borderColor: colors.secondary,
//                 color: colors.secondary,
//                 fontWeight: 'bold',
//                 '&:hover': {
//                   backgroundColor: colors.secondary,
//                   color: colors.textLight,
//                 }
//               }}
//             />
//           ))}
//         </Box>
//       </Box>

//       {/* Filtration Tabs */}
//       <Box 
//         className="property-requests-tabs-container"
//         sx={{
//           width: '100%',
//           bgcolor: colors.cardBackground,
//           borderBottom: 1,
//           borderColor: 'divider'
//         }}
//       >
//         <Tabs
//           className="property-requests-tabs"
//           value={activeTab}
//           onChange={handleTabChange}
//           variant="scrollable"
//           scrollButtons="auto"
//           aria-label="property type tabs"
//           sx={{
//             '& .MuiTab-root': {
//               fontSize: '0.8rem',
//               fontWeight: 'bold',
//               color: colors.textMuted,
//               minWidth: 'auto',
//               px: 2,
//               '&.Mui-selected': {
//                 color: colors.secondary,
//               }
//             },
//             '& .MuiTabs-indicator': {
//               backgroundColor: colors.secondary,
//             }
//           }}
//         >
//           {tabs.map((tab, index) => (
//             <Tab 
//               key={index} 
//               className={`property-requests-tab-${tab.label.toLowerCase().replace(' ', '-')}`}
//               label={tab.label} 
//             />
//           ))}
//         </Tabs>
//       </Box>

//       {/* Location Selection Dialog */}
//       <Dialog
//         className="property-requests-location-dialog"
//         open={locationDialogOpen}
//         onClose={() => setLocationDialogOpen(false)}
//         maxWidth="sm"
//         fullWidth
//       >
//         <DialogTitle className="property-requests-location-dialog-title">
//           <Box display="flex" justifyContent="space-between" alignItems="center">
//             <Typography variant="h6">Add Locations</Typography>
//             <IconButton 
//               className="property-requests-location-dialog-close"
//               onClick={() => setLocationDialogOpen(false)}
//             >
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent className="property-requests-location-dialog-content">
//           <FormControlLabel
//             className="property-requests-current-location-checkbox"
//             control={
//               <Checkbox
//                 checked={useCurrentLocation}
//                 onChange={() => handleUseCurrentLocation(useCurrentLocation, setUseCurrentLocation, setSelectedLocations)}
//                 sx={{ color: colors.secondary }}
//               />
//             }
//             label="Use my current location"
//           />

//           <Typography 
//             className="property-requests-add-locations-title"
//             variant="subtitle1" 
//             sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}
//           >
//             Add Locations
//           </Typography>

//           <Box 
//             className="property-requests-selected-locations-chips"
//             sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}
//           >
//             {selectedLocations.map((location, index) => (
//               <Chip
//                 key={index}
//                 className="property-requests-selected-location-dialog-chip"
//                 label={`+ ${location}`}
//                 onDelete={() => handleLocationRemove(selectedLocations, setSelectedLocations, location)}
//                 sx={{
//                   backgroundColor: colors.secondary,
//                   color: colors.textLight,
//                   '& .MuiChip-deleteIcon': {
//                     color: colors.textLight,
//                   }
//                 }}
//               />
//             ))}
//           </Box>

//           <Typography 
//             className="property-requests-popular-cities-dialog-title"
//             variant="subtitle1" 
//             sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}
//           >
//             Popular cities in India
//           </Typography>

//           <Box 
//             className="property-requests-popular-cities-dialog-chips"
//             sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}
//           >
//             {popularCities.map((city, index) => (
//               <Chip
//                 key={index}
//                 className="property-requests-popular-city-dialog-chip"
//                 label={`+${city}`}
//                 onClick={() => handleLocationSelect(selectedLocations, setSelectedLocations, city)}
//                 variant="outlined"
//                 sx={{
//                   borderColor: colors.secondary,
//                   color: colors.secondary,
//                   '&:hover': {
//                     backgroundColor: colors.secondary,
//                     color: colors.textLight,
//                   }
//                 }}
//               />
//             ))}
//           </Box>
//         </DialogContent>
//         <DialogActions className="property-requests-location-dialog-actions" sx={{ p: 2 }}>
//           <Button
//             className="property-requests-apply-locations-button"
//             onClick={applyFilters}
//             variant="contained"
//             fullWidth
//             sx={{
//               backgroundColor: colors.secondary,
//               color: colors.textLight,
//               '&:hover': {
//                 backgroundColor: colors.accent
//               }
//             }}
//           >
//             Apply
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Property Type Selection Dialog */}
//       <Dialog
//         className="property-requests-type-dialog"
//         open={propertyTypeDialogOpen}
//         onClose={() => setPropertyTypeDialogOpen(false)}
//         maxWidth="sm"
//         fullWidth
//       >
//         <DialogTitle className="property-requests-type-dialog-title">
//           <Box display="flex" justifyContent="space-between" alignItems="center">
//             <Typography variant="h6">Select Property Type</Typography>
//             <IconButton 
//               className="property-requests-type-dialog-close"
//               onClick={() => setPropertyTypeDialogOpen(false)}
//             >
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent className="property-requests-type-dialog-content">
//           <List className="property-requests-type-list">
//             {propertyTypes.map((type, index) => (
//               <ListItem
//                 key={index}
//                 className={`property-requests-type-list-item property-requests-type-${type.toLowerCase().replace(' ', '-')}`}
//                 button
//                 onClick={() => handlePropertyTypeSelect(selectedPropertyTypes, setSelectedPropertyTypes, type)}
//                 sx={{
//                   borderBottom: '1px solid #e0e0e0',
//                   '&:last-child': {
//                     borderBottom: 'none'
//                   }
//                 }}
//               >
//                 <Checkbox
//                   className="property-requests-type-checkbox"
//                   checked={selectedPropertyTypes.includes(type)}
//                   sx={{ color: colors.secondary }}
//                 />
//                 <ListItemText primary={type} />
//               </ListItem>
//             ))}
//           </List>
//         </DialogContent>
//         <DialogActions className="property-requests-type-dialog-actions" sx={{ p: 2 }}>
//           <Button
//             className="property-requests-apply-types-button"
//             onClick={applyFilters}
//             variant="contained"
//             fullWidth
//             sx={{
//               backgroundColor: colors.secondary,
//               color: colors.textLight,
//               '&:hover': {
//                 backgroundColor: colors.accent
//               }
//             }}
//           >
//             Apply
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Content - Property Cards */}
//       <Box 
//         className="property-requests-cards-container"
//         sx={{ p: 1.5, flex: 1, pb: 10, backgroundColor: colors.background }}
//       >
//         {filteredProperties.length === 0 ? (
//           <Typography 
//             className="property-requests-no-results"
//             variant="h6" 
//             textAlign="center" 
//             sx={{ mt: 4, color: colors.textDark }}
//           >
//             No properties found for {tabs[activeTab]?.label}
//           </Typography>
//         ) : (
//           <Box 
//             className="property-requests-cards-list"
//             sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}
//           >
//             {filteredProperties.map((property, index) => (
//               <Card
//                 key={property.req_id}
//                 className="property-requests-card"
//                 sx={{
//                   borderRadius: 2,
//                   boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
//                   border: `1px solid #e0e0e0`,
//                   overflow: 'hidden'
//                 }}
//               >
//                 <CardContent 
//                   className="property-requests-card-content"
//                   sx={{ 
//                     backgroundColor: colors.cardBackground,
//                     p: 0, // Remove padding from card content
//                     '&:last-child': {
//                       pb: 0 // Remove bottom padding for last child
//                     }
//                   }}
//                 >
//                   {/* Property Header - Ultra Compact */}
//                   <Box 
//                     className="property-requests-card-header"
//                     sx={{
//                       p: 1,
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'space-between',
//                       backgroundColor: colors.primary,
//                     }}
//                   >
//                     <Typography 
//                       className="property-requests-card-title"
//                       variant="h6" 
//                       fontWeight="bold" 
//                       color={colors.textLight} 
//                       sx={{ fontSize: '0.9rem' }}
//                     >
//                       {property.looking_for ?
//                         property.looking_for.charAt(0).toUpperCase() + property.looking_for.slice(1)
//                         : "Property"
//                       }
//                     </Typography>
//                     <Typography
//                       className="property-requests-card-budget"
//                       variant="subtitle1"
//                       fontWeight="bold"
//                       color={colors.textLight}
//                       sx={{ lineHeight: 1, fontSize: '0.8rem' }}
//                     >
//                       Budget: 
//                       {formatBudget(property.min_budget, property.max_budget)}
//                     </Typography>
//                   </Box>

//                   {/* Property Details - Ultra Compact */}
//                   <Box 
//                     className="property-requests-card-details"
//                     sx={{ p: 1.5 }}
//                   >
//                     {/* Compact details in single column */}
//                     <Box 
//                       className="property-requests-details-grid"
//                       sx={{ display: 'grid', gap: 0.75 }}
//                     >
//                       <Box 
//                         className="property-requests-type-detail"
//                         sx={{ display: 'flex', alignItems: 'flex-start' }}
//                       >
//                         <Typography 
//                           className="property-requests-detail-label"
//                           variant="body2" 
//                           color={colors.textDark} 
//                           sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 70 }}
//                         >
//                           <strong>Type:</strong>
//                         </Typography>
//                         <Typography 
//                           className="property-requests-detail-value"
//                           variant="body2" 
//                           color={colors.textDark} 
//                           sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}
//                         >
//                           {property.property_type || "Not specified"}
//                         </Typography>
//                       </Box>

//                       <Box 
//                         className="property-requests-location-detail"
//                         sx={{ display: 'flex', alignItems: 'flex-start' }}
//                       >
//                         <Typography 
//                           className="property-requests-detail-label"
//                           variant="body2" 
//                           color={colors.textDark} 
//                           sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 70 }}
//                         >
//                           <strong>Location:</strong>
//                         </Typography>
//                         <Typography 
//                           className="property-requests-detail-value"
//                           variant="body2" 
//                           color={colors.textDark} 
//                           sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}
//                         >
//                           {property.location || "Not specified"}
//                         </Typography>
//                       </Box>

//                       {(property.area > 0 || property.min_acres > 0) && (
//                         <Box 
//                           className="property-requests-size-detail"
//                           sx={{ display: 'flex', alignItems: 'flex-start' }}
//                         >
//                           <Typography 
//                             className="property-requests-detail-label"
//                             variant="body2" 
//                             color={colors.textDark} 
//                             sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 70 }}
//                           >
//                             <strong>Size:</strong>
//                           </Typography>
//                           <Typography 
//                             className="property-requests-detail-value"
//                             variant="body2" 
//                             color={colors.textDark} 
//                             sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}
//                           >
//                             {property.area > 0
//                               ? `${property.area} ${property.units || 'sq ft'}`
//                               : property.min_acres > 0
//                                 ? `${property.min_acres}-${property.max_acres} acres`
//                                 : "Not specified"}
//                           </Typography>
//                         </Box>
//                       )}

//                       {property.ratio && (
//                         <Box 
//                           className="property-requests-ratio-detail"
//                           sx={{ display: 'flex', alignItems: 'flex-start' }}
//                         >
//                           <Typography 
//                             className="property-requests-detail-label"
//                             variant="body2" 
//                             color={colors.textDark} 
//                             sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 70 }}
//                           >
//                             <strong>Ratio:</strong>
//                           </Typography>
//                           <Typography 
//                             className="property-requests-detail-value"
//                             variant="body2" 
//                             color={colors.textDark} 
//                             sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}
//                           >
//                             {property.ratio}
//                           </Typography>
//                         </Box>
//                       )}
//                     </Box>

//                     {/* User Info Section - Ultra Compact with Date, Responses and Comment button all in one line */}
//                     <Box 
//                       className="property-requests-user-info"
//                       sx={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'space-between',
//                         mt: 1.5,
//                         pt: 1,
//                         borderTop: '1px solid #e0e0e0'
//                       }}
//                     >
//                       <Box 
//                         className="property-requests-user-avatar-container"
//                         sx={{ display: 'flex', alignItems: 'center' }}
//                       >
//                         <Avatar 
//                           className="property-requests-user-avatar"
//                           sx={{
//                             width: 24,
//                             height: 24,
//                             mr: 1,
//                             bgcolor: colors.secondary,
//                             color: colors.textLight,
//                             fontSize: '0.6rem'
//                           }}
//                         >
//                           {getUserInitials(property.user_id)}
//                         </Avatar>
//                         <Typography 
//                           className="property-requests-user-name"
//                           variant="body2" 
//                           color={colors.textMuted} 
//                           sx={{ fontSize: '0.7rem' }}
//                         >
//                           User {property.user_id}
//                         </Typography>
//                       </Box>

//                       <Box 
//                         className="property-requests-meta-info"
//                         sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
//                       >
//                         <Typography 
//                           className="property-requests-date"
//                           variant="body2" 
//                           color={colors.textMuted} 
//                           sx={{ fontSize: '0.7rem' }}
//                         >
//                           {formatDate(property.created_at)}
//                         </Typography>

//                         {/* Responses count beside date */}
//                         {responses[property.req_id] && responses[property.req_id].length > 0 && (
//                           <Box 
//                             className="property-requests-responses-count"
//                             sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}
//                           >
//                             <ChatBubbleOutlineIcon sx={{ fontSize: '0.8rem', color: colors.secondary }} />
//                             <Typography
//                               className="property-requests-responses-number"
//                               variant="body2"
//                               sx={{
//                                 fontSize: '0.7rem',
//                                 color: colors.secondary,
//                                 fontWeight: 'bold'
//                               }}
//                             >
//                               {responses[property.req_id].length}
//                             </Typography>
//                           </Box>
//                         )}

//                         {/* Comment button beside date and responses */}
//                         <IconButton
//                           className="property-requests-comment-button"
//                           size="small"
//                           onClick={() => handleCommentClick(index)}
//                           sx={{
//                             color: colors.textLight,
//                             backgroundColor: colors.secondary,
//                             '&:hover': { backgroundColor: colors.accent },
//                             width: 24,
//                             height: 24
//                           }}
//                         >
//                           <ChatBubbleOutlineIcon sx={{ fontSize: '0.8rem' }} />
//                         </IconButton>
//                       </Box>
//                     </Box>

//                     {/* Additional Comments - Only show if essential */}
//                     {property.comment && property.comment !== "Property request from form" && property.comment.length < 100 && (
//                       <Box 
//                         className="property-requests-additional-comments"
//                         sx={{
//                           mt: 1,
//                           p: 1,
//                           backgroundColor: '#f5f2ee',
//                           borderRadius: 0.5,
//                           borderLeft: `2px solid ${colors.secondary}`
//                         }}
//                       >
//                         <Typography 
//                           className="property-requests-comment-text"
//                           variant="body2" 
//                           color={colors.textDark} 
//                           fontStyle="italic" 
//                           sx={{ fontSize: '0.7rem', lineHeight: 1.2 }}
//                         >
//                           "{property.comment.length > 80 ? property.comment.substring(0, 80) + '...' : property.comment}"
//                         </Typography>
//                       </Box>
//                     )}
//                   </Box>

//                   {/* Show Responses button only if there are responses */}
//                   {(responses[property.req_id] && responses[property.req_id].length > 0) && (
//                     <Box 
//                       className="property-requests-show-responses-container"
//                       sx={{
//                         p: 1,
//                         display: 'flex',
//                         justifyContent: 'flex-start',
//                         alignItems: 'center',
//                         backgroundColor: '#f8f8f8',
//                         borderTop: '1px solid #e0e0e0'
//                       }}
//                     >
//                       <Button
//                         className="property-requests-show-responses-button"
//                         size="small"
//                         onClick={() => toggleResponses(property.req_id)}
//                         sx={{
//                           color: colors.secondary,
//                           fontSize: '0.65rem',
//                           minWidth: 'auto',
//                           px: 0.5,
//                           textTransform: 'none'
//                         }}
//                         endIcon={expandedResponses[property.req_id] ? <ExpandLessIcon sx={{ fontSize: '0.8rem' }} /> : <ExpandMoreIcon sx={{ fontSize: '0.8rem' }} />}
//                       >
//                         {expandedResponses[property.req_id] ? 'Hide Responses' : 'Show Responses'}
//                       </Button>
//                     </Box>
//                   )}

//                   {/* Collapsible Responses Section - Compact */}
//                   {responses[property.req_id] && responses[property.req_id].length > 0 && (
//                     <Collapse in={expandedResponses[property.req_id]}>
//                       <Box 
//                         className="property-requests-responses-container"
//                         sx={{ p: 1, backgroundColor: '#fafafa' }}
//                       >
//                         {responses[property.req_id].slice(0, 2).map((response, responseIndex) => (
//                           <Box
//                             key={responseIndex}
//                             className="property-requests-response-item"
//                             sx={{
//                               mb: 1,
//                               p: 1,
//                               backgroundColor: 'white',
//                               borderRadius: 0.5,
//                               boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
//                               border: '1px solid #e0e0e0'
//                             }}
//                           >
//                             <Box 
//                               className="property-requests-response-header"
//                               sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}
//                             >
//                               <Avatar 
//                                 className="property-requests-response-avatar"
//                                 sx={{
//                                   width: 20,
//                                   height: 20,
//                                   mr: 0.75,
//                                   bgcolor: colors.secondary,
//                                   fontSize: '0.6rem',
//                                   color: colors.textLight
//                                 }}
//                               >
//                                 U
//                               </Avatar>
//                               <Box 
//                                 className="property-requests-response-user-info"
//                                 sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}
//                               >
//                                 <Typography 
//                                   className="property-requests-response-user-name"
//                                   variant="caption" 
//                                   fontWeight="bold" 
//                                   color={colors.primary} 
//                                   sx={{ fontSize: '0.65rem' }}
//                                 >
//                                   User {response.user_id}
//                                 </Typography>
//                                 <Typography 
//                                   className="property-requests-response-date"
//                                   variant="caption" 
//                                   color={colors.textMuted} 
//                                   sx={{ fontSize: '0.6rem' }}
//                                 >
//                                   {formatDate(response.created_at || new Date())}
//                                 </Typography>
//                               </Box>
//                             </Box>

//                             {response.comment && (
//                               <Typography 
//                                 className="property-requests-response-comment"
//                                 variant="body2" 
//                                 sx={{ color: colors.textDark, lineHeight: 1.2, fontSize: '0.7rem' }}
//                               >
//                                 Click on below link to view the property.
//                                 {/* {response.comment.length > 60 ? response.comment.substring(0, 60) + '...' : response.comment} */}
//                               </Typography>
//                             )}

//                             {response.proerty_link && (
//                               <Box 
//                                 className="property-requests-response-link-container"
//                                 sx={{ mt: 0.5 }}
//                               >
//                               <Typography
//   className="property-requests-response-link"
//   component="a"
//   href={response.proerty_link}
//   sx={{
//     color: '#1976d2',
//     textDecoration: 'underline',
//     fontSize: '0.65rem',
//     '&:hover': {
//       color: '#1565c0',
//       textDecoration: 'underline'
//     }
//   }}
// >
//   🔗 Property Link
// </Typography>

//                               </Box>
//                             )}
//                           </Box>
//                         ))}
//                         {responses[property.req_id].length > 2 && (
//                           <Typography 
//                             className="property-requests-more-responses"
//                             variant="caption" 
//                             color={colors.textMuted} 
//                             sx={{ fontSize: '0.65rem', textAlign: 'center', display: 'block' }}
//                           >
//                             +{responses[property.req_id].length - 2} more responses
//                           </Typography>
//                         )}
//                       </Box>
//                     </Collapse>
//                   )}

//                   {/* Comment Input (shown when comment icon is clicked) */}
//                   {activeCommentIndex === index && (
//                     <Box 
//                       className="property-requests-comment-input-container"
//                       sx={{
//                         p: 1,
//                         backgroundColor: '#f5f2ee',
//                         borderTop: `1px solid ${colors.secondary}`
//                       }}
//                     >
//                       {/* <TextField
//                         className="property-requests-comment-text-field"
//                         fullWidth
//                         variant="outlined"
//                         placeholder="Add a comment..."
//                         value={commentText}
//                         onChange={(e) => setCommentText(e.target.value)}
//                         size="small"
//                         sx={{ mb: 0.75 }}
//                         InputProps={{
//                           sx: {
//                             fontSize: '0.75rem',
//                             '& input': { py: 0.75 }
//                           }
//                         }}
//                       /> */}
//                       <TextField
//                         className="property-requests-link-text-field"
//                         fullWidth
//                         variant="outlined"
//                         placeholder="Upload the Property ad place url here"
//                         value={propertyLink}
//                         onChange={(e) => setPropertyLink(e.target.value)}
//                         size="small"
//                         sx={{ mb: 1 }}
//                         InputProps={{
//                           sx: {
//                             fontSize: '0.75rem',
//                             '& input': { py: 0.75 }
//                           }
//                         }}
//                       />
//                       <Box 
//                         className="property-requests-comment-actions"
//                         sx={{ display: 'flex', justifyContent: 'flex-end', gap: 0.5 }}
//                       >
//                         <Button
//                           className="property-requests-cancel-comment-button"
//                           size="small"
//                           onClick={() => handleCommentClick(index)}
//                           sx={{ color: colors.secondary, fontSize: '0.65rem', minWidth: 'auto', px: 1 }}
//                         >
//                           Cancel
//                         </Button>
//                         <Button
//                           className="property-requests-submit-comment-button"
//                           variant="contained"
//                           size="small"
//                           onClick={() => handleSubmitResponse(property.req_id, 1)}
//                           disabled={submitting || (!commentText.trim() && !propertyLink.trim())}
//                           sx={{
//                             backgroundColor: colors.secondary,
//                             color: colors.textLight,
//                             fontSize: '0.65rem',
//                             minWidth: 'auto',
//                             px: 1,
//                             '&:hover': {
//                               backgroundColor: colors.accent
//                             }
//                           }}
//                         >
//                           {submitting ? "..." : "Submit"}
//                         </Button>
//                       </Box>
//                     </Box>
//                   )}
//                 </CardContent>
//               </Card>
//             ))}
//           </Box>
//         )}
//       </Box>

//       {/* Footer */}
//       <Box 
//         className="property-requests-footer"
//         sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}
//       >
//         <FormsBottomNavbar />
//       </Box>
//     </Box>
//   );
// };

// export default OnePage;

// Import filtration utilities
// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   AppBar,
//   Toolbar,
//   IconButton,
//   TextField,
//   Card,
//   CardContent,
//   InputAdornment,
//   Avatar,
//   Divider,
//   Button,
//   Collapse,
//   Tabs,
//   Tab,
//   Grid,
//   Chip,
//   Checkbox,
//   FormControlLabel,
//   Paper,
//   List,
//   ListItem,
//   ListItemText,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions
// } from "@mui/material";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import SearchIcon from "@mui/icons-material/Search";
// import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import ExpandLessIcon from "@mui/icons-material/ExpandLess";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import AddIcon from "@mui/icons-material/Add";
// import CloseIcon from "@mui/icons-material/Close";
// import { useNavigate } from "react-router-dom";
// import FormsBottomNavbar from "../Post Module/FormsBottomNavbar";
// import { tabs, popularCities, propertyTypes, filterProperties, locationHandlers, propertyTypeHandlers, utilityFunctions } from "./propertyFilters";

// const OnePage = () => {
//   const navigate = useNavigate();
//   const [searchQuery, setSearchQuery] = useState("");
//   const [activeCommentIndex, setActiveCommentIndex] = useState(null);
//   const [commentText, setCommentText] = useState("");
//   const [propertyLink, setPropertyLink] = useState("");
//   const [properties, setProperties] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [responses, setResponses] = useState({});
//   const [submitting, setSubmitting] = useState(false);
//   const [expandedResponses, setExpandedResponses] = useState({});
//   const [activeTab, setActiveTab] = useState(0);
//   const [locationDialogOpen, setLocationDialogOpen] = useState(false);
//   const [selectedLocations, setSelectedLocations] = useState([]);
//   const [useCurrentLocation, setUseCurrentLocation] = useState(false);
//   const [propertyTypeDialogOpen, setPropertyTypeDialogOpen] = useState(false);
//   const [selectedPropertyTypes, setSelectedPropertyTypes] = useState([]);

//   const colors = {
//     primary: "#1a1a1a", secondary: "#8B7355", accent: "#A52A2A", 
//     background: "#b9a990", cardBackground: "#FFFFFF", textDark: "#1a1a1a", 
//     textLight: "#FFFFFF", textMuted: "#666666"
//   };

//   // Property link validation patterns
//   const getValidLinkPatterns = () => {
//     const basePatterns = {
//       Purchase: [/^https?:\/\/landnest\.net\/buy-description\/\d+$/, /^https?:\/\/localhost:3000\/buy-description\/\d+$/],
//       Rent: [/^https?:\/\/landnest\.net\/rent-description\/\d+$/, /^https?:\/\/localhost:3000\/rent-description\/\d+$/],
//       Lease: [/^https?:\/\/landnest\.net\/lease-description\/\d+$/, /^https?:\/\/localhost:3000\/lease-description\/\d+$/]
//     };
//     return basePatterns[tabs[activeTab]?.label] || [/^https?:\/\/landnest\.net\/.+\/\d+$/, /^https?:\/\/localhost:3000\/.+\/\d+$/];
//   };

//   const isValidPropertyLink = (link) => {
//     const patterns = getValidLinkPatterns();
//     return patterns.some(pattern => pattern.test(link));
//   };

//   useEffect(() => {
//     const fetchProperties = async () => {
//       try {
//         setLoading(true);
//         const response = await fetch(`${BASE_URL}/property-request/`);
//         if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
//         const data = await response.json();
//         setProperties(data.slice().reverse());
//         setError(null);
//       } catch (err) {
//         console.error("Error fetching properties:", err);
//         setError("Failed to load properties. Please try again later.");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchProperties();
//   }, []);

//   useEffect(() => {
//     const fetchResponses = async () => {
//       try {
//         const response = await fetch(`${BASE_URL}/response-property-request/`);
//         if (response.ok) {
//           const data = await response.json();
//           const responsesByReqId = {};
//           data.forEach(response => {
//             if (!responsesByReqId[response.req_id]) responsesByReqId[response.req_id] = [];
//             responsesByReqId[response.req_id].push(response);
//           });
//           setResponses(responsesByReqId);
//         }
//       } catch (err) {
//         console.error("Error fetching responses:", err);
//       }
//     };
//     fetchResponses();
//   }, []);

//   const { formatBudget, formatDate, getUserInitials } = utilityFunctions;
//   const { handleLocationSelect, handleLocationRemove, handleUseCurrentLocation } = locationHandlers;
//   const { handlePropertyTypeSelect } = propertyTypeHandlers;

//   const handleCommentClick = (index) => {
//     setActiveCommentIndex(activeCommentIndex === index ? null : index);
//     setCommentText("");
//     setPropertyLink("");
//   };

//   const handleSubmitResponse = async (reqId, userId) => {
//     if (!commentText.trim() && !propertyLink.trim()) {
//       alert("Please enter either a comment or property link");
//       return;
//     }

//     if (propertyLink.trim() && !isValidPropertyLink(propertyLink.trim())) {
//       const currentTab = tabs[activeTab]?.label;
//       const validExamples = {
//         Purchase: "https://landnest.net/buy-description/162 or http://localhost:3000/buy-description/59",
//         Rent: "https://landnest.net/rent-description/162 or http://localhost:3000/rent-description/88", 
//         Lease: "https://landnest.net/lease-description/162 or http://localhost:3000/lease-description/99"
//       };
//       alert(`Invalid property link for ${currentTab} section.\n\nValid examples:\n${validExamples[currentTab] || "Please use proper landnest.net links"}`);
//       return;
//     }

//     setSubmitting(true);
//     try {
//       const response = await fetch(`${BASE_URL}/response-property-request/`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ comment: commentText, proerty_link: propertyLink, req_id: reqId, user_id: userId }),
//       });

//       if (response.ok) {
//         const newResponse = await response.json();
//         setResponses(prev => ({ ...prev, [reqId]: [...(prev[reqId] || []), newResponse] }));
//         setCommentText("");
//         setPropertyLink("");
//         setActiveCommentIndex(null);
//         alert("Response submitted successfully!");
//       } else throw new Error("Failed to submit response");
//     } catch (err) {
//       console.error("Error submitting response:", err);
//       alert("Failed to submit response. Please try again.");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const toggleResponses = (reqId) => {
//     setExpandedResponses(prev => ({ ...prev, [reqId]: !prev[reqId] }));
//   };

//   const handleTabChange = (event, newValue) => setActiveTab(newValue);
//   const applyFilters = () => {
//     setLocationDialogOpen(false);
//     setPropertyTypeDialogOpen(false);
//   };

//   const filteredProperties = filterProperties(properties, { searchQuery, activeTab, selectedLocations, selectedPropertyTypes, tabs });

//   if (loading) return (
//     <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: colors.background, justifyContent: "center", alignItems: "center" }}>
//       <Typography variant="h6" color={colors.textDark}>Loading properties...</Typography>
//     </Box>
//   );

//   if (error) return (
//     <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: colors.background, justifyContent: "center", alignItems: "center" }}>
//       <Typography variant="h6" color="error">{error}</Typography>
//     </Box>
//   );

//   const renderDialogActions = () => (
//     <DialogActions sx={{ p: 2 }}>
//       <Button onClick={applyFilters} variant="contained" fullWidth sx={{ backgroundColor: colors.secondary, color: colors.textLight, '&:hover': { backgroundColor: colors.accent } }}>
//         Apply
//       </Button>
//     </DialogActions>
//   );

//   const renderPropertyDetail = (label, value) => value && (
//     <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
//       <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 70 }}><strong>{label}:</strong></Typography>
//       <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}>{value}</Typography>
//     </Box>
//   );

//   return (
//     <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: colors.background }}>
//       <AppBar position="static" sx={{ backgroundColor: colors.primary, color: colors.textLight }}>
//         <Toolbar>
//           <IconButton onClick={() => navigate(-1)} sx={{ color: colors.textLight }}><ArrowBackIosNewIcon /></IconButton>
//           <Typography variant="h6" sx={{ ml: 2 }}>Property Requests</Typography>
//         </Toolbar>
//       </AppBar>

//       <Box sx={{ p: 2, backgroundColor: colors.cardBackground }}>
//         <TextField fullWidth variant="outlined" placeholder="Search upto 3 localities or landmarks" value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)} InputProps={{ startAdornment: (<InputAdornment position="start"><SearchIcon sx={{ color: colors.secondary }} /></InputAdornment>) }}
//           sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2, backgroundColor: '#f8f8f8', '&:hover fieldset, &.Mui-focused fieldset': { borderColor: colors.secondary } } }} />
//       </Box>

//       <Box sx={{ p: 2, backgroundColor: colors.cardBackground, borderBottom: '1px solid #e0e0e0' }}>
//         <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 1 }}>
//           <Chip label="Add Locations" onClick={() => setLocationDialogOpen(true)} variant="outlined" deleteIcon={<AddIcon />} onDelete={() => setLocationDialogOpen(true)}
//             sx={{ borderColor: colors.secondary, color: colors.secondary, '& .MuiChip-deleteIcon': { color: colors.secondary } }} />
//           <Chip label="Plot/ Building" onClick={() => setPropertyTypeDialogOpen(true)} variant="outlined" deleteIcon={<AddIcon />} onDelete={() => setPropertyTypeDialogOpen(true)}
//             sx={{ borderColor: colors.secondary, color: colors.secondary, '& .MuiChip-deleteIcon': { color: colors.secondary } }} />
//         </Box>
//         {selectedLocations.map((location, index) => (
//           <Chip key={index} label={location} onDelete={() => handleLocationRemove(selectedLocations, setSelectedLocations, location)}
//             sx={{ m: 0.5, backgroundColor: colors.secondary, color: colors.textLight, '& .MuiChip-deleteIcon': { color: colors.textLight } }} />
//         ))}
//       </Box>

//       <Box sx={{ p: 2, backgroundColor: colors.cardBackground }}>
//         <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', color: colors.primary }}>Popular cities in India</Typography>
//         <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//           {popularCities.map((city, index) => (
//             <Chip key={index} label={city} onClick={() => handleLocationSelect(selectedLocations, setSelectedLocations, city)} variant="outlined"
//               sx={{ borderColor: colors.secondary, color: colors.secondary, fontWeight: 'bold', '&:hover': { backgroundColor: colors.secondary, color: colors.textLight } }} />
//           ))}
//         </Box>
//       </Box>

//       <Box sx={{ width: '100%', bgcolor: colors.cardBackground, borderBottom: 1, borderColor: 'divider' }}>
//         <Tabs value={activeTab} onChange={handleTabChange} variant="scrollable" scrollButtons="auto"
//           sx={{ '& .MuiTab-root': { fontSize: '0.8rem', fontWeight: 'bold', color: colors.textMuted, minWidth: 'auto', px: 2, '&.Mui-selected': { color: colors.secondary } }, '& .MuiTabs-indicator': { backgroundColor: colors.secondary } }}>
//           {tabs.map((tab, index) => (<Tab key={index} label={tab.label} />))}
//         </Tabs>
//       </Box>

//       <Dialog open={locationDialogOpen} onClose={() => setLocationDialogOpen(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>
//           <Box display="flex" justifyContent="space-between" alignItems="center">
//             <Typography variant="h6">Add Locations</Typography>
//             <IconButton onClick={() => setLocationDialogOpen(false)}><CloseIcon /></IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <FormControlLabel control={<Checkbox checked={useCurrentLocation} onChange={() => handleUseCurrentLocation(useCurrentLocation, setUseCurrentLocation, setSelectedLocations)} sx={{ color: colors.secondary }} />} label="Use my current location" />
//           <Typography variant="subtitle1" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>Add Locations</Typography>
//           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
//             {selectedLocations.map((location, index) => (
//               <Chip key={index} label={`+ ${location}`} onDelete={() => handleLocationRemove(selectedLocations, setSelectedLocations, location)}
//                 sx={{ backgroundColor: colors.secondary, color: colors.textLight, '& .MuiChip-deleteIcon': { color: colors.textLight } }} />
//             ))}
//           </Box>
//           <Typography variant="subtitle1" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>Popular cities in India</Typography>
//           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//             {popularCities.map((city, index) => (
//               <Chip key={index} label={`+${city}`} onClick={() => handleLocationSelect(selectedLocations, setSelectedLocations, city)} variant="outlined"
//                 sx={{ borderColor: colors.secondary, color: colors.secondary, '&:hover': { backgroundColor: colors.secondary, color: colors.textLight } }} />
//             ))}
//           </Box>
//         </DialogContent>
//         {renderDialogActions()}
//       </Dialog>

//       <Dialog open={propertyTypeDialogOpen} onClose={() => setPropertyTypeDialogOpen(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>
//           <Box display="flex" justifyContent="space-between" alignItems="center">
//             <Typography variant="h6">Select Property Type</Typography>
//             <IconButton onClick={() => setPropertyTypeDialogOpen(false)}><CloseIcon /></IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <List>
//             {propertyTypes.map((type, index) => (
//               <ListItem key={index} button onClick={() => handlePropertyTypeSelect(selectedPropertyTypes, setSelectedPropertyTypes, type)} sx={{ borderBottom: '1px solid #e0e0e0', '&:last-child': { borderBottom: 'none' } }}>
//                 <Checkbox checked={selectedPropertyTypes.includes(type)} sx={{ color: colors.secondary }} />
//                 <ListItemText primary={type} />
//               </ListItem>
//             ))}
//           </List>
//         </DialogContent>
//         {renderDialogActions()}
//       </Dialog>

//       <Box sx={{ p: 1.5, flex: 1, pb: 10, backgroundColor: colors.background }}>
//         {filteredProperties.length === 0 ? (
//           <Typography variant="h6" textAlign="center" sx={{ mt: 4, color: colors.textDark }}>No properties found for {tabs[activeTab]?.label}</Typography>
//         ) : (
//           <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
//             {filteredProperties.map((property, index) => (
//               <Card key={property.req_id} sx={{ borderRadius: 2, boxShadow: '0 2px 8px rgba(0,0,0,0.1)', border: `1px solid #e0e0e0`, overflow: 'hidden' }}>
//                 <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
//                   <Box sx={{ p: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: colors.primary }}>
//                     <Typography variant="h6" fontWeight="bold" color={colors.textLight} sx={{ fontSize: '0.9rem' }}>
//                       {property.looking_for ? property.looking_for.charAt(0).toUpperCase() + property.looking_for.slice(1) : "Property"}
//                     </Typography>
//                     <Typography variant="subtitle1" fontWeight="bold" color={colors.textLight} sx={{ lineHeight: 1, fontSize: '0.8rem' }}>
//                       Budget: {formatBudget(property.min_budget, property.max_budget)}
//                     </Typography>
//                   </Box>

//                   <Box sx={{ p: 1.5 }}>
//                     <Box sx={{ display: 'grid', gap: 0.75 }}>
//                       {renderPropertyDetail("Type", property.property_type || "Not specified")}
//                       {renderPropertyDetail("Location", property.location || "Not specified")}
//                       {(property.area > 0 || property.min_acres > 0) && renderPropertyDetail("Size", property.area > 0 ? `${property.area} ${property.units || 'sq ft'}` : `${property.min_acres}-${property.max_acres} acres`)}
//                       {property.ratio && renderPropertyDetail("Ratio", property.ratio)}
//                     </Box>

//                     <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 1.5, pt: 1, borderTop: '1px solid #e0e0e0' }}>
//                       <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                         <Avatar sx={{ width: 24, height: 24, mr: 1, bgcolor: colors.secondary, color: colors.textLight, fontSize: '0.6rem' }}>
//                           {getUserInitials(property.user_id)}
//                         </Avatar>
//                         <Typography variant="body2" color={colors.textMuted} sx={{ fontSize: '0.7rem' }}>User {property.user_id}</Typography>
//                       </Box>

//                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                         <Typography variant="body2" color={colors.textMuted} sx={{ fontSize: '0.7rem' }}>{formatDate(property.created_at)}</Typography>
//                         {responses[property.req_id]?.length > 0 && (
//                           <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
//                             <ChatBubbleOutlineIcon sx={{ fontSize: '0.8rem', color: colors.secondary }} />
//                             <Typography variant="body2" sx={{ fontSize: '0.7rem', color: colors.secondary, fontWeight: 'bold' }}>{responses[property.req_id].length}</Typography>
//                           </Box>
//                         )}
//                         <IconButton size="small" onClick={() => handleCommentClick(index)} sx={{ color: colors.textLight, backgroundColor: colors.secondary, '&:hover': { backgroundColor: colors.accent }, width: 24, height: 24 }}>
//                           <ChatBubbleOutlineIcon sx={{ fontSize: '0.8rem' }} />
//                         </IconButton>
//                       </Box>
//                     </Box>

//                     {property.comment && property.comment !== "Property request from form" && property.comment.length < 100 && (
//                       <Box sx={{ mt: 1, p: 1, backgroundColor: '#f5f2ee', borderRadius: 0.5, borderLeft: `2px solid ${colors.secondary}` }}>
//                         <Typography variant="body2" color={colors.textDark} fontStyle="italic" sx={{ fontSize: '0.7rem', lineHeight: 1.2 }}>
//                           "{property.comment.length > 80 ? property.comment.substring(0, 80) + '...' : property.comment}"
//                         </Typography>
//                       </Box>
//                     )}
//                   </Box>

//                   {responses[property.req_id]?.length > 0 && (
//                     <Box sx={{ p: 1, display: 'flex', justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#f8f8f8', borderTop: '1px solid #e0e0e0' }}>
//                       <Button size="small" onClick={() => toggleResponses(property.req_id)} sx={{ color: colors.secondary, fontSize: '0.65rem', minWidth: 'auto', px: 0.5, textTransform: 'none' }}
//                         endIcon={expandedResponses[property.req_id] ? <ExpandLessIcon sx={{ fontSize: '0.8rem' }} /> : <ExpandMoreIcon sx={{ fontSize: '0.8rem' }} />}>
//                         {expandedResponses[property.req_id] ? 'Hide Responses' : 'Show Responses'}
//                       </Button>
//                     </Box>
//                   )}

//                   {responses[property.req_id]?.length > 0 && (
//                     <Collapse in={expandedResponses[property.req_id]}>
//                       <Box sx={{ p: 1, backgroundColor: '#fafafa' }}>
//                         {responses[property.req_id].slice(0, 2).map((response, responseIndex) => (
//                           <Box key={responseIndex} sx={{ mb: 1, p: 1, backgroundColor: 'white', borderRadius: 0.5, boxShadow: '0 1px 3px rgba(0,0,0,0.1)', border: '1px solid #e0e0e0' }}>
//                             <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
//                               <Avatar sx={{ width: 20, height: 20, mr: 0.75, bgcolor: colors.secondary, fontSize: '0.6rem', color: colors.textLight }}>U</Avatar>
//                               <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
//                                 <Typography variant="caption" fontWeight="bold" color={colors.primary} sx={{ fontSize: '0.65rem' }}>User {response.user_id}</Typography>
//                                 <Typography variant="caption" color={colors.textMuted} sx={{ fontSize: '0.6rem' }}>{formatDate(response.created_at || new Date())}</Typography>
//                               </Box>
//                             </Box>
//                             {response.comment && <Typography variant="body2" sx={{ color: colors.textDark, lineHeight: 1.2, fontSize: '0.7rem' }}>Click on below link to view the property.</Typography>}
//                             {response.proerty_link && (
//                               <Box sx={{ mt: 0.5 }}>
//                                 <Typography component="a" href={response.proerty_link} sx={{ color: '#1976d2', textDecoration: 'underline', fontSize: '0.65rem', '&:hover': { color: '#1565c0', textDecoration: 'underline' } }}>🔗 Property Link</Typography>
//                               </Box>
//                             )}
//                           </Box>
//                         ))}
//                         {responses[property.req_id].length > 2 && (
//                           <Typography variant="caption" color={colors.textMuted} sx={{ fontSize: '0.65rem', textAlign: 'center', display: 'block' }}>+{responses[property.req_id].length - 2} more responses</Typography>
//                         )}
//                       </Box>
//                     </Collapse>
//                   )}

//                   {activeCommentIndex === index && (
//                     <Box sx={{ p: 1, backgroundColor: '#f5f2ee', borderTop: `1px solid ${colors.secondary}` }}>
//                       <TextField fullWidth variant="outlined" placeholder="Paste property link (landnest.net or localhost:3000)" value={propertyLink} onChange={(e) => setPropertyLink(e.target.value)} size="small" sx={{ mb: 1 }}
//                         InputProps={{ sx: { fontSize: '0.75rem', '& input': { py: 0.75 } } }} />
//                       <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 0.5 }}>
//                         <Button size="small" onClick={() => handleCommentClick(index)} sx={{ color: colors.secondary, fontSize: '0.65rem', minWidth: 'auto', px: 1 }}>Cancel</Button>
//                         <Button variant="contained" size="small" onClick={() => handleSubmitResponse(property.req_id, 1)} disabled={submitting || (!commentText.trim() && !propertyLink.trim())}
//                           sx={{ backgroundColor: colors.secondary, color: colors.textLight, fontSize: '0.65rem', minWidth: 'auto', px: 1, '&:hover': { backgroundColor: colors.accent } }}>
//                           {submitting ? "..." : "Submit"}
//                         </Button>
//                       </Box>
//                     </Box>
//                   )}
//                 </CardContent>
//               </Card>
//             ))}
//           </Box>
//         )}
//       </Box>

//       <Box sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}><FormsBottomNavbar /></Box>
//     </Box>
//   );
// };

// export default OnePage;


//=====================================
// length and width setup 

import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  AppBar,
  Toolbar,
  IconButton,
  TextField,
  Card,
  CardContent,
  InputAdornment,
  Avatar,
  Divider,
  Button,
  Collapse,
  Tabs,
  Tab,
  Grid,
  Chip,
  Checkbox,
  FormControlLabel,
  Paper,
  List,
  ListItem,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import SearchIcon from "@mui/icons-material/Search";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import FormsBottomNavbar from "../Post Module/FormsBottomNavbar";
import { tabs, popularCities, propertyTypes, filterProperties, locationHandlers, propertyTypeHandlers, utilityFunctions } from "./propertyFilters";
import { BASE_URL } from "../../Api/ApiUrls";

const OnePage = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [activeCommentIndex, setActiveCommentIndex] = useState(null);
  const [commentText, setCommentText] = useState("");
  const [propertyLink, setPropertyLink] = useState("");
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [responses, setResponses] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [expandedResponses, setExpandedResponses] = useState({});
  const [activeTab, setActiveTab] = useState(0);
  const [locationDialogOpen, setLocationDialogOpen] = useState(false);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [useCurrentLocation, setUseCurrentLocation] = useState(false);
  const [propertyTypeDialogOpen, setPropertyTypeDialogOpen] = useState(false);
  const [selectedPropertyTypes, setSelectedPropertyTypes] = useState([]);

  const colors = {
    primary: "#1a1a1a", secondary: "#8B7355", accent: "#A52A2A",
    background: "#b9a990", cardBackground: "#FFFFFF", textDark: "#1a1a1a",
    textLight: "#FFFFFF", textMuted: "#666666"
  };

  // Property link validation patterns
const getValidLinkPatterns = () => {
  const basePatterns = {
    Purchase: [
      /^https?:\/\/landnest\.net\/buy-description\/\d+$/,
      /^https?:\/\/localhost:3000\/buy-description\/\d+$/,
      /^https?:\/\/app\.propertypincoder\.com\/buy-description\/\d+$/
    ],
    Rent: [
      /^https?:\/\/landnest\.net\/rent-description\/\d+$/,
      /^https?:\/\/localhost:3000\/rent-description\/\d+$/,
      /^https?:\/\/app\.propertypincoder\.com\/rent-description\/\d+$/
    ],
    Lease: [
      /^https?:\/\/landnest\.net\/lease-description\/\d+$/,
      /^https?:\/\/localhost:3000\/lease-description\/\d+$/,
      /^https?:\/\/app\.propertypincoder\.com\/lease-description\/\d+$/
    ]
  };

  return (
    basePatterns[tabs[activeTab]?.label] || [
      /^https?:\/\/landnest\.net\/.+\/\d+$/,
      /^https?:\/\/localhost:3000\/.+\/\d+$/,
      /^https?:\/\/app\.propertypincoder\.com\/.+\/\d+$/
    ]
  );
};


  const isValidPropertyLink = (link) => {
    const patterns = getValidLinkPatterns();
    return patterns.some(pattern => pattern.test(link));
  };

  // Format dimensions function
  const formatDimensions = (property) => {
    if (property.length > 0 && property.width > 0) {
      const area = property.length * property.width;
      const units = property.units || 'ft';
      return `${property.length}*${property.width} (${area}) ${units === 'm' ? 'sq m' : 'sq ft'}`;
    }
    return null;
  };

  // Function to navigate to all responses page
  const handleViewAllResponses = (property) => {
    navigate('/all-responses', {
      state: {
        responses: responses[property.req_id] || [],
        propertyDetails: property
      }
    });
  };

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${BASE_URL}/property-request/`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const data = await response.json();
        setProperties(data.slice().reverse());
        setError(null);
      } catch (err) {
        console.error("Error fetching properties:", err);
        setError("Failed to load properties. Please try again later.");
      } finally {
        setLoading(false);
      }
    };
    fetchProperties();
  }, []);

  useEffect(() => {
    const fetchResponses = async () => {
      try {
        const response = await fetch(`${BASE_URL}/response-property-request/`);
        if (response.ok) {
          const data = await response.json();
          const responsesByReqId = {};
          data.forEach(response => {
            if (!responsesByReqId[response.req_id]) responsesByReqId[response.req_id] = [];
            responsesByReqId[response.req_id].push(response);
          });
          setResponses(responsesByReqId);
        }
      } catch (err) {
        console.error("Error fetching responses:", err);
      }
    };
    fetchResponses();
  }, []);

  const { formatBudget, formatDate, getUserInitials } = utilityFunctions;
  const { handleLocationSelect, handleLocationRemove, handleUseCurrentLocation } = locationHandlers;
  const { handlePropertyTypeSelect } = propertyTypeHandlers;

  const handleCommentClick = (index) => {
    setActiveCommentIndex(activeCommentIndex === index ? null : index);
    setCommentText("");
    setPropertyLink("");
  };

  const handleSubmitResponse = async (reqId, userId) => {
    if (!commentText.trim() && !propertyLink.trim()) {
      alert("Please enter either a comment or property link");
      return;
    }

    if (propertyLink.trim() && !isValidPropertyLink(propertyLink.trim())) {
      const currentTab = tabs[activeTab]?.label;
      const validExamples = {
Purchase:
  "https://landnest.net/buy-description/162 or http://localhost:3000/buy-description/59 or https://app.propertypincoder.com/buy-description/162",

Rent:
  "https://landnest.net/rent-description/162 or http://localhost:3000/rent-description/88 or https://app.propertypincoder.com/rent-description/162",

Lease:
  "https://landnest.net/lease-description/162 or http://localhost:3000/lease-description/99 or https://app.propertypincoder.com/lease-description/162"

};
      alert(`Invalid property link for ${currentTab} section.\n\nValid examples:\n${validExamples[currentTab] || "Please use proper landnest.net links"}`);
      return;
    }

    setSubmitting(true);
    try {
      const response = await fetch(`${BASE_URL}/response-property-request/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ comment: commentText, proerty_link: propertyLink, req_id: reqId, user_id: userId }),
      });

      if (response.ok) {
        const newResponse = await response.json();
        setResponses(prev => ({ ...prev, [reqId]: [...(prev[reqId] || []), newResponse] }));
        setCommentText("");
        setPropertyLink("");
        setActiveCommentIndex(null);
        alert("Response submitted successfully!");
      } else throw new Error("Failed to submit response");
    } catch (err) {
      console.error("Error submitting response:", err);
      alert("Failed to submit response. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  const toggleResponses = (reqId) => {
    setExpandedResponses(prev => ({ ...prev, [reqId]: !prev[reqId] }));
  };

  const handleTabChange = (event, newValue) => setActiveTab(newValue);
  const applyFilters = () => {
    setLocationDialogOpen(false);
    setPropertyTypeDialogOpen(false);
  };

  const filteredProperties = filterProperties(properties, { searchQuery, activeTab, selectedLocations, selectedPropertyTypes, tabs });

  if (loading) return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: colors.background, justifyContent: "center", alignItems: "center" }}>
      <Typography variant="h6" color={colors.textDark}>Loading properties...</Typography>
    </Box>
  );

  if (error) return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: colors.background, justifyContent: "center", alignItems: "center" }}>
      <Typography variant="h6" color={error}>{error}</Typography>
    </Box>
  );

  const renderDialogActions = () => (
    <DialogActions sx={{ p: 2 }}>
      <Button onClick={applyFilters} variant="contained" fullWidth sx={{ backgroundColor: colors.secondary, color: colors.textLight, '&:hover': { backgroundColor: colors.accent } }}>
        Apply
      </Button>
    </DialogActions>
  );

  const renderPropertyDetail = (label, value) => value && (
    <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
      <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 70 }}><strong>{label}:</strong></Typography>
      <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}>{value}</Typography>
    </Box>
  );

  const renderResponseItem = (response, index) => (
    <Box key={index} sx={{ mb: 1, p: 1, backgroundColor: 'white', borderRadius: 0.5, boxShadow: '0 1px 3px rgba(0,0,0,0.1)', border: '1px solid #e0e0e0' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
        <Avatar sx={{ width: 20, height: 20, mr: 0.75, bgcolor: colors.secondary, fontSize: '0.6rem', color: colors.textLight }}>U</Avatar>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <Typography variant="caption" fontWeight="bold" color={colors.primary} sx={{ fontSize: '0.65rem' }}>User {response.user_id}</Typography>
          <Typography variant="caption" color={colors.textMuted} sx={{ fontSize: '0.6rem' }}>{formatDate(response.created_at || new Date())}</Typography>
        </Box>
      </Box>
      {response.comment && <Typography variant="body2" sx={{ color: colors.textDark, lineHeight: 1.2, fontSize: '0.7rem' }}>Click on below link to view the property.</Typography>}
      {response.proerty_link && (
        <Box sx={{ mt: 0.5 }}>
          <Typography component="a" href={response.proerty_link} target="_blank" rel="noopener noreferrer"
            sx={{ color: '#1976d2', textDecoration: 'underline', fontSize: '0.65rem', '&:hover': { color: '#1565c0', textDecoration: 'underline' } }}>
            🔗 Property Link
          </Typography>
        </Box>
      )}
    </Box>
  );

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: colors.background }}>
      <AppBar position="sticky" sx={{ backgroundColor: colors.primary, color: colors.textLight }}>
        <Toolbar>
          <IconButton onClick={() => navigate(-1)} sx={{ color: colors.textLight }}><ArrowBackIosNewIcon /></IconButton>
          <Typography variant="h6" sx={{ ml: 2 }}>Property Requests</Typography>
        </Toolbar>
      </AppBar>

      <Box sx={{ p: 2, backgroundColor: colors.cardBackground }}>
        <TextField fullWidth variant="outlined" placeholder="Search upto 3 localities or landmarks" value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)} InputProps={{ startAdornment: (<InputAdornment position="start"><SearchIcon sx={{ color: colors.secondary }} /></InputAdornment>) }}
          sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2, backgroundColor: '#f8f8f8', '&:hover fieldset, &.Mui-focused fieldset': { borderColor: colors.secondary } } }} />
      </Box>

      <Box sx={{ p: 2, backgroundColor: colors.cardBackground, borderBottom: '1px solid #e0e0e0' }}>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 1 }}>
          <Chip label="Add Locations" onClick={() => setLocationDialogOpen(true)} variant="outlined" deleteIcon={<AddIcon />} onDelete={() => setLocationDialogOpen(true)}
            sx={{ borderColor: colors.secondary, color: colors.secondary, '& .MuiChip-deleteIcon': { color: colors.secondary } }} />
          <Chip label="Plot/ Building" onClick={() => setPropertyTypeDialogOpen(true)} variant="outlined" deleteIcon={<AddIcon />} onDelete={() => setPropertyTypeDialogOpen(true)}
            sx={{ borderColor: colors.secondary, color: colors.secondary, '& .MuiChip-deleteIcon': { color: colors.secondary } }} />
        </Box>
        {selectedLocations.map((location, index) => (
          <Chip key={index} label={location} onDelete={() => handleLocationRemove(selectedLocations, setSelectedLocations, location)}
            sx={{ m: 0.5, backgroundColor: colors.secondary, color: colors.textLight, '& .MuiChip-deleteIcon': { color: colors.textLight } }} />
        ))}
      </Box>

      <Box sx={{ p: 2, backgroundColor: colors.cardBackground }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', color: colors.primary }}>Popular cities in India</Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {popularCities.map((city, index) => (
            <Chip key={index} label={city} onClick={() => handleLocationSelect(selectedLocations, setSelectedLocations, city)} variant="outlined"
              sx={{ borderColor: colors.secondary, color: colors.secondary, fontWeight: 'bold', '&:hover': { backgroundColor: colors.secondary, color: colors.textLight } }} />
          ))}
        </Box>
      </Box>

      <Box sx={{ width: '100%', bgcolor: colors.cardBackground, borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={activeTab} onChange={handleTabChange} variant="scrollable" scrollButtons="auto"
          sx={{ '& .MuiTab-root': { fontSize: '0.8rem', fontWeight: 'bold', color: colors.textMuted, minWidth: 'auto', px: 2, '&.Mui-selected': { color: colors.secondary } }, '& .MuiTabs-indicator': { backgroundColor: colors.secondary } }}>
          {tabs.map((tab, index) => (<Tab key={index} label={tab.label} />))}
        </Tabs>
      </Box>

      <Dialog open={locationDialogOpen} onClose={() => setLocationDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Add Locations</Typography>
            <IconButton onClick={() => setLocationDialogOpen(false)}><CloseIcon /></IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <FormControlLabel control={<Checkbox checked={useCurrentLocation} onChange={() => handleUseCurrentLocation(useCurrentLocation, setUseCurrentLocation, setSelectedLocations)} sx={{ color: colors.secondary }} />} label="Use my current location" />
          <Typography variant="subtitle1" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>Add Locations</Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
            {selectedLocations.map((location, index) => (
              <Chip key={index} label={`+ ${location}`} onDelete={() => handleLocationRemove(selectedLocations, setSelectedLocations, location)}
                sx={{ backgroundColor: colors.secondary, color: colors.textLight, '& .MuiChip-deleteIcon': { color: colors.textLight } }} />
            ))}
          </Box>
          <Typography variant="subtitle1" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>Popular cities in India</Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {popularCities.map((city, index) => (
              <Chip key={index} label={`+${city}`} onClick={() => handleLocationSelect(selectedLocations, setSelectedLocations, city)} variant="outlined"
                sx={{ borderColor: colors.secondary, color: colors.secondary, '&:hover': { backgroundColor: colors.secondary, color: colors.textLight } }} />
            ))}
          </Box>
        </DialogContent>
        {renderDialogActions()}
      </Dialog>

      <Dialog open={propertyTypeDialogOpen} onClose={() => setPropertyTypeDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Select Property Type</Typography>
            <IconButton onClick={() => setPropertyTypeDialogOpen(false)}><CloseIcon /></IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <List>
            {propertyTypes.map((type, index) => (
              <ListItem key={index} button onClick={() => handlePropertyTypeSelect(selectedPropertyTypes, setSelectedPropertyTypes, type)} sx={{ borderBottom: '1px solid #e0e0e0', '&:last-child': { borderBottom: 'none' } }}>
                <Checkbox checked={selectedPropertyTypes.includes(type)} sx={{ color: colors.secondary }} />
                <ListItemText primary={type} />
              </ListItem>
            ))}
          </List>
        </DialogContent>
        {renderDialogActions()}
      </Dialog>

      <Box sx={{ p: 1.5, flex: 1, pb: 10, backgroundColor: colors.background }}>
        {filteredProperties.length === 0 ? (
          <Typography variant="h6" textAlign="center" sx={{ mt: 4, color: colors.textDark }}>No properties found for {tabs[activeTab]?.label}</Typography>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            {filteredProperties.map((property, index) => (
              <Card key={property.req_id} sx={{ borderRadius: 2, boxShadow: '0 2px 8px rgba(0,0,0,0.1)', border: `1px solid #e0e0e0`, overflow: 'hidden' }}>
                <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
                  {/* Updated header section with Purchase and Budget in separate boxes */}
                  <Box sx={{ p: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: colors.primary }}>
                    {/* Purchase Section - Black Background */}
                    <Box sx={{ 
                      backgroundColor: "#b9a990", 
                      color: colors.primary,
                      px: 1.5,
                      py: 0.5,
                      borderRadius: 3,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <Typography variant="h6" fontWeight="bold" sx={{ fontSize: '0.9rem', lineHeight: 1 }}>
                        {property.looking_for ? property.looking_for.charAt(0).toUpperCase() + property.looking_for.slice(1) : "Property"}
                      </Typography>
                    </Box>
                    
                    {/* Budget Section - Brown Background */}
                    <Box sx={{ 
                      backgroundColor: colors.cardBackground, 
                      color: colors.primary,
                      px: 1.5,
                      py: 0.5,
                      borderRadius: 3,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <Typography variant="subtitle1" fontWeight="bold" sx={{ lineHeight: 1, fontSize: '0.9rem' }}>
                        Budget: {formatBudget(property.min_budget, property.max_budget)}
                      </Typography>
                    </Box>
                  </Box>

                  <Box sx={{ p: 1.5 }}>
                    <Box sx={{ display: 'grid', gap: 0.75 }}>
                      {/* Type */}
                      <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                        <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 90, flexShrink: 0 }}>
                          <strong>Property Type:</strong>
                        </Typography>
                        <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}>
                          {property.property_type || "Not specified"}
                        </Typography>
                      </Box>

                      {/* Location */}
                      <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                        <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 90, flexShrink: 0 }}>
                          <strong>Location:</strong>
                        </Typography>
                        <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}>
                          {property.location || "Not specified"}
                        </Typography>
                      </Box>

                      {/* Dimensions when available */}
                      {formatDimensions(property) && (
                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                          <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 90, flexShrink: 0 }}>
                            <strong>Length*Width:</strong>
                          </Typography>
                          <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}>
                            {formatDimensions(property)}
                          </Typography>
                        </Box>
                      )}
                      
                      {/* Fallback to area if dimensions not available */}
                      {(property.area > 0 && !formatDimensions(property)) && (
                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                          <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 90, flexShrink: 0 }}>
                            <strong>Length*Width:</strong>
                          </Typography>
                          <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}>
                            {`${property.area} ${property.units || 'sq ft'}`}
                          </Typography>
                        </Box>
                      )}
                      
                      {/* Fallback to acres if neither dimensions nor area available */}
                      {((property.min_acres > 0 || property.max_acres > 0) && !formatDimensions(property) && property.area <= 0) && (
                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                          <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 90, flexShrink: 0 }}>
                            <strong>Length*Width:</strong>
                          </Typography>
                          <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}>
                            {`${property.min_acres}${property.max_acres > property.min_acres ? `-${property.max_acres}` : ''} acres`}
                          </Typography>
                        </Box>
                      )}
                      
                      {/* Ratio */}
                      {property.ratio && (
                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                          <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 80, flexShrink: 0 }}>
                            <strong>Ratio:</strong>
                          </Typography>
                          <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}>
                            {property.ratio}
                          </Typography>
                        </Box>
                      )}

                      {/* User and Date as key-value pairs */}
                      <Box sx={{ display: 'flex', alignItems: 'flex-start', mt: 0.5 }}>
                          <Avatar sx={{ width: 16, height: 16,  fontSize: '0.5rem' }}>
                            👤
                          </Avatar>
                        <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 75, flexShrink: 0 }}>
                          <strong>CUST {property.user_id}</strong>
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        
                          <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}>
                          {formatDate(property.created_at)}
                        </Typography>
                        </Box>
                      </Box>
                    </Box>

                    {/* Responses and Comment Button - Right aligned */}
                    <Box sx={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'space-between', 
                      gap: 1, 
                      mt: 1, 
                      pt: 1, 
                      borderTop: '1px solid #e0e0e0' 
                    }}>
                      {/* Left side - Toggle Responses Button */}
                      <Button 
                        size="small" 
                        onClick={() => toggleResponses(property.req_id)} 
                        sx={{ 
                          color: colors.secondary, 
                          fontSize: '0.65rem', 
                          minWidth: 'auto', 
                          px: 0.5, 
                          textTransform: 'none',
                          fontWeight: 'bold'
                        }}
                        endIcon={expandedResponses[property.req_id] ? 
                          <ExpandLessIcon sx={{ fontSize: '0.8rem' }} /> : 
                          <ExpandMoreIcon sx={{ fontSize: '0.8rem' }} />
                        }
                      >
                        {expandedResponses[property.req_id] ? 'Hide' : 'Show'} Responses
                      </Button>
                      
                      {/* Right side - Responses count and Comment Button */}
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <ChatBubbleOutlineIcon sx={{ fontSize: '0.8rem', color: colors.secondary }} />
                        <Typography variant="body2" sx={{ fontSize: '0.7rem', color: colors.secondary, fontWeight: 'bold' }}>
                          {responses[property.req_id]?.length || 0}
                        </Typography>
                        <IconButton 
                          size="small" 
                          onClick={() => handleCommentClick(index)} 
                          sx={{ 
                            color: colors.textLight, 
                            backgroundColor: colors.secondary, 
                            '&:hover': { backgroundColor: colors.accent }, 
                            width: 24, 
                            height: 24 
                          }}
                        >
                          <ChatBubbleOutlineIcon sx={{ fontSize: '0.8rem' }} />
                        </IconButton>
                      </Box>
                    </Box>

                    {/* User comment */}
                    {property.comment && property.comment !== "Property request from form" && property.comment.length < 100 && (
                      <Box sx={{ mt: 1, p: 1, backgroundColor: '#f5f2ee', borderRadius: 0.5, borderLeft: `2px solid ${colors.secondary}` }}>
                        <Typography variant="body2" color={colors.textDark} fontStyle="italic" sx={{ fontSize: '0.7rem', lineHeight: 1.2 }}>
                          "{property.comment.length > 80 ? property.comment.substring(0, 80) + '...' : property.comment}"
                        </Typography>
                      </Box>
                    )}
                  </Box>

                  {/* Expanded Responses */}
                  {responses[property.req_id]?.length > 0 && (
                    <Collapse in={expandedResponses[property.req_id]}>
                      <Box sx={{ p: 1, backgroundColor: '#fafafa' }}>
                        {/* Show only 1 response initially */}
                        {responses[property.req_id].slice(0, 1).map((response, responseIndex) => renderResponseItem(response, responseIndex))}
                        
                        {/* Show "View All" button if there are more responses */}
                        {responses[property.req_id].length > 1 && (
                          <Box sx={{ textAlign: 'center', mt: 1 }}>
                            <Button 
                              size="small" 
                              onClick={() => handleViewAllResponses(property)}
                              sx={{ 
                                color: colors.secondary, 
                                fontSize: '0.65rem', 
                                textTransform: 'none',
                                fontWeight: 'bold'
                              }}
                            >
                              + {responses[property.req_id].length - 1} more responses
                            </Button>
                          </Box>
                        )}
                      </Box>
                    </Collapse>
                  )}

                  {/* Comment Input Section */}
                  {activeCommentIndex === index && (
                    <Box sx={{ p: 1, backgroundColor: '#f5f2ee', borderTop: `1px solid ${colors.secondary}` }}>
                      <TextField 
                        fullWidth 
                        variant="outlined" 
                        placeholder="Paste property link (landnest.net or localhost:3000)" 
                        value={propertyLink} 
                        onChange={(e) => setPropertyLink(e.target.value)} 
                        size="small" 
                        sx={{ mb: 1 }}
                        InputProps={{ sx: { fontSize: '0.75rem', '& input': { py: 0.75 } } }} 
                      />
                      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 0.5 }}>
                        <Button 
                          size="small" 
                          onClick={() => handleCommentClick(index)} 
                          sx={{ color: colors.secondary, fontSize: '0.65rem', minWidth: 'auto', px: 1 }}
                        >
                          Cancel
                        </Button>
                        <Button 
                          variant="contained" 
                          size="small" 
                          onClick={() => handleSubmitResponse(property.req_id, 1)} 
                          disabled={submitting || (!commentText.trim() && !propertyLink.trim())}
                          sx={{ 
                            backgroundColor: colors.secondary, 
                            color: colors.textLight, 
                            fontSize: '0.65rem', 
                            minWidth: 'auto', 
                            px: 1, 
                            '&:hover': { backgroundColor: colors.accent } 
                          }}
                        >
                          {submitting ? "..." : "Submit"}
                        </Button>
                      </Box>
                    </Box>
                  )}
                </CardContent>
              </Card>
            ))}
          </Box>
        )}
      </Box>

      <Box sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}><FormsBottomNavbar /></Box>
    </Box>
  );
};

export default OnePage;